import * as styles from "./MeterTrack.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { Meter as BaseMeter } from "@base-ui/react/meter";

import type { MeterTrackProps } from "./Meter.types";

export function MeterTrack({
  className,
  ...props
}: MeterTrackProps): JSX.Element {
  return (
    <BaseMeter.Track
      data-slot="meter-track"
      className={clsx(styles.track, className)}
      {...props}
    />
  );
}
